let API_BASE;
export default API_BASE = 'https://smarttap.world/wp-json/smarttap/v2/'; 
//export default API_BASE = 'http://112.196.54.37:3001/'; 



